import { TReduxActions } from '../../../common/actions';
import { IFrecklesFeaturesMap } from '../../../common/types/freckles';
import { EFetchMapDataActionType } from '../../actions';

export const defaultState: IFrecklesFeaturesMap = {};

export const frecklesReducer = (state = defaultState, action: TReduxActions) => {
  switch (action.type) {
    case EFetchMapDataActionType.Succeed: {
      return action.payload.freckles;
    }
    case EFetchMapDataActionType.Failed: {
      return defaultState;
    }
    default: {
      return state;
    }
  }
};
